import { Button } from "src/elements";
import { useTranslation } from "src/i18n";
import { useCdtCategoryTreeQuery } from "src/pages/CDTTreeEditor/store/useCdtCategoryTreeQuery";
import { useNavigation } from "src/utils/navigation";
import { pages } from "src/utils/pages";

interface Props {
  categoryId: number;
  isDisabled?: boolean;
}

export const CdtTreeButton = ({ categoryId, isDisabled }: Props) => {
  const { navigate } = useNavigation();
  const { t } = useTranslation("common");
  const { refetch, isFetching } = useCdtCategoryTreeQuery(categoryId, false);

  const handleNavigateToTree = async () => {
    try {
      await refetch();
    } catch {
      // Navigate so the editor can render its query error state.
    } finally {
      navigate(`${pages.cdtTreeEditor}?categoryId=${categoryId}`);
    }
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      size="small"
      isDisabled={isDisabled}
      isLoading={isFetching}
      onClick={handleNavigateToTree}
    >
      {t("cdtTreeEditor.button")}
    </Button>
  );
};
